import React from "react"

import PropTypes from "prop-types"
import {Icon} from "semantic-ui-react"

import "./style.scss"

export const ICON_COUNTER_VARIANTS = {
    DEFAULT: "default",
}

const IconCounter = ({
    counterValue,
    icon,
    iconSize = "2rem",
    variant = ICON_COUNTER_VARIANTS.DEFAULT,
    badgeVerticalOffset = 0,
    badgeHorizontalOffset = 0,
    ...props
}) => (
    <div
        className="icon-counter"
        style={{
            "--icon-size": iconSize,
            "--badge-vertical-offset": `${badgeVerticalOffset}%`,
            "--badge-horizontal-offset": `${badgeHorizontalOffset}%`,
        }}
        {...props}
    >
        <Icon aria-hidden="true" className={icon} />
        {!!counterValue && <div className="counter-badge">{counterValue}</div>}
    </div>
)

IconCounter.propTypes = {
    badgeHorizontalOffset: PropTypes.number,
    badgeVerticalOffset: PropTypes.number,
    counterValue: PropTypes.number.isRequired,
    icon: PropTypes.string.isRequired,
    iconSize: PropTypes.number,
    variant: PropTypes.oneOf(Object.values(ICON_COUNTER_VARIANTS)),
}

export default IconCounter
